import getApprovalPermission from './get-approval-permission';

interface IUser {
  permissions: {
    min_price?: number;
    max_price?: number;
    feature: {
      price_range?: boolean;
      project_procedure_id: string;
    };
  }[];
}

interface IGetEditProjPerm {
  status: string;
  ft_proj_proc_id: string;
  user: IUser;
  approval_min_price?: number | null;
  approval_max_price?: number | null;
}

export default function getEditProjPerm({
  status,
  ft_proj_proc_id,
  user,
  approval_min_price,
  approval_max_price,
}: IGetEditProjPerm): boolean {
  if (status !== 'Cancelado' && status !== 'Finalizado') {
    const perm = user.permissions.find(
      p => p.feature.project_procedure_id === ft_proj_proc_id,
    );

    if (perm) {
      if (perm.feature.price_range) {
        if (
          getApprovalPermission({
            perm_min_price: perm.min_price,
            perm_max_price: perm.max_price,
            approval_min_price,
            approval_max_price,
          })
        ) {
          return true;
        }
      } else {
        return true;
      }
    }
  }

  return false;
}
